export var dash = {
    900: '#FD6C00',
    800: '#FC8D00',
    700: '#FC9E00',
    600: '#FBB100',
    500: '#FABF00',
    400: '#FBC913',
    300: '#FBD346',
    200: '#FCDF7D',
    100: '#FDEBB0',
    50: '#FEF8E0',
};
//# sourceMappingURL=dash.js.map